import React from "react";
import {Form, Button, Alert} from "react-bootstrap";

class CreateBookListForm extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data: {
            "bookListId": props.bookId,
            "booklist_title": "",
            "booklist_description": "",
            "total_noof_books": 0
        },

        errors:{},
        isSubmit: "no",
        loading: false
      };
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    onSubmit = (e) => {
        e.preventDefault();
        this.props.submit(this.state.data);      
    };
    render(){
        const {booklist_title, booklist_description} = this.state.data;
        const {loading} = this.state;
        return(
            <div>
                <Form className="form_comn" onSubmit={this.onSubmit}>
                {this.state.errors.error && (
                    <Alert variant="danger">{this.state.errors.error}</Alert>
                )}
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Booklist Title</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Write Your Booklist Name"
                        name="booklist_title"
                        value = {booklist_title}
                        onChange={this.onchange}
                        autoComplete="off"
                        required
                    />
                  </Form.Group>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Booklist Description</Form.Label>
                    <Form.Control 
                        as="textarea" 
                        name="booklist_description" 
                        value={booklist_description} 
                        onChange={this.onchange}
                        required 
                        rows="3" 
                    />
                  </Form.Group>
                  <Button variant="success" className="create_book_btn" type = "submit">Create the Booklist</Button> 
                </Form>
                {loading && (
                <div className="loader">
                    <div></div>
                    <h1>Please Wait...</h1>
                </div>
                )}
            </div>
        );
    };
};

export default CreateBookListForm;